export const inventoryLineData1 = [
    {
      name: "Jan",
      uv: 1600,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const inventoryLineData2 = [
    {
      name: "Jan",
      uv: 1600,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 500,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const inventoryLineData3 = [
    {
      name: "Jan",
      uv: 1600,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 500,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const CRMLineData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 500,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const WareHouseLineData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 500,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const BILineData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 500,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  export const LogisticsLineData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 500,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "June",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "July",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Sep",
      uv: 1500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Oct",
      uv: 2500,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      uv: 2700,
      pv: 4300,
      amt: 2100,
    },
    {
      name: "Dec",
      uv: 3000,
      pv: 4300,
      amt: 2100,
    },
  ];
  